<!-- 事件列表 -->
<template>
    <div class='left1_wrapper box box_v' ref="monitor_event">
        <div class="title">事件上报</div>
        <div class="tr" :style="'height:'+height">
            <div id="scroll_wrapper_event" :style="'height:'+contentheight+';marginTop:'+marginTop">
                <div class="list_item box" v-for="(item,index) in list" 
                    :key="index" 
                    :class="{'active':index==selectIndex}"
                    :style="'height:'+itemHeight"
                >
                    <div class="box box_f1 box_v" >
                        <div class="box" style="align-items:center">
                            <div class="dot"></div>
                            <div class="slh" style="width:240px">{{item.content}}</div>
                        </div>
                        <div class="box_f1 box box_between" style="align-items:center">
                            <div class="area">{{item.userName}}</div>
                            <div class="item_text">{{item.creatTime}}</div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            list:[],
            height:'100%',
            contentheight:'100%',
            selectIndex:0,
            marginTop:"0px",
            timer:null,
            itemHeight:'60px'
        };
    },
    props:{
        show:{
            type:Boolean,
            default:false
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        show:{
            handler(newVal){
                if(newVal){
                    this.list=[]
                    this.selectIndex = 0
                    this.marginTop ='0px' 
                    this.getData()
                }else{
                    console.log('left1.destroy')
                    this.timer && clearInterval(this.timer)
                }
            },
            immediate:true
        }
    },
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.monitor_eventList,{
                pageNum:1,
                pageSize:6
            }).then(res=>{
               this.list = res.rows
               
               this.handelScroll()
            })
        },
        handelScroll(){
            let height = this.$refs.monitor_event.offsetHeight - 87
            this.height = height + 'px'
            let itemHeight = height/5-10   
            this.itemHeight = itemHeight + 'px'

            let num = 1
            let contentheight = this.list.length * (itemHeight+10)
            this.contentheight = contentheight + 'px'
        
            if(height<contentheight){
                //没有显示完整
                this.timer = setInterval(()=>{
                    if(num*(itemHeight+12)<=contentheight){
                        this.selectIndex = this.selectIndex+1
                        this.marginTop ='-'+num*(itemHeight+10)+'px' 
                        num++
                        console.log(num)
                    }else{
                        this.selectIndex = 0
                        num = 1
                        this.marginTop ='0px' 
                    }
                },3000)
            }
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.left1_wrapper{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/estate/left1.png');
    background-size: 100% 100%;
    height:100%;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    padding:30px 40px;
}

.tr{
    width:100%;
    padding: 0 10px 10px 10px;
    //flex-wrap:wrap;
    overflow: hidden;
    #scroll_wrapper{
        //transition-timing-function: linear;
        //display: flex;
        //flex-wrap: wrap;
        width: 100%
    }
}
.list_item{
    margin: 0 0px 10px 0px;
    //padding: 10px 0;
    border-top:1px dashed #00A0E9;
    border-bottom: 1px dashed #00A0E9;
    align-items: center;
    color:#09D4FF;
    font-size: 14px;
    .dot{
        background: #97DE00;
        border-radius: 50%;
        height:8px;
        width:8px;
        margin-right:5px
    }
    .area{
        //width: 52px;
        height: 14px;
        padding:0 7px;
        color:#FFA025;
        font-size: 14px;
        line-height: 14px;
        margin-left: 13px;
        margin-top: 2px;
        border-left:1px solid #FFA025;
        border-right:1px solid #FFA025;
    }
    .item_text{
        color:#9EB7BC
    }

}
.active{
        box-shadow:0 0 20px #00A0E9 inset; 
    // border:none;
    // color:#34FFB5;
}
</style>